import { useMemo } from 'react';
import { SlateCopilotDataPoint } from 'libs/end-to-end/src/copilot';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { GetLevelByColumnValueFn } from 'libs/end-to-end/src/dimension';
import { BasicCopilotOutputState } from 'apps/sigma2-ui/src/copilot/types/BasicCopilotOutputState';
import { createSlateCopilotDataPoints } from 'libs/end-to-end/src/copilot-utils';

export const useBasicCopilotSlateCopilotDataPoints = ({
  currentState,
  getLevelByColumnValue,
  selectedSlateIds,
}: {
  currentState: BasicCopilotOutputState;
  getLevelByColumnValue: GetLevelByColumnValueFn;
  selectedSlateIds: string[];
}): SlateCopilotDataPoint[] => {
  return useMemo<SlateCopilotDataPoint[]>(() => {
    if (currentState.state !== 'success') {
      return [];
    }

    return createSlateCopilotDataPoints(
      currentState.output,
      getLevelByColumnValue,
      selectedSlateIds,
    );
  }, [currentState, getLevelByColumnValue, selectedSlateIds]);
};
